import { occUrl } from "~/app/api/occ/occFetch";
import { apiGET } from "~/app/api/apiCallsService";
import {
  type AvailabilityInfo,
  type AvailabilityInfoDTO,
  transformAvailability,
} from "~/domains/product/api/pna/AvailabilityInfo";

const apiUrl = occUrl("/pna/getLcAvailability");

export async function getLinearAvailabilityInfo(
  productCode: string,
  configurationId: string,
  activeCartId?: string,
): Promise<AvailabilityInfo> {
  const params = new URLSearchParams();
  if (activeCartId) {
    params.set("activeCartId", activeCartId);
  }
  const query = params.toString();
  const url = `${apiUrl}/${productCode}/${configurationId}${query ? `?${query}` : ""}`;
  const response = await apiGET(url);
  if (!response.ok) {
    throw new Error("Error fetching data");
  }
  const dto = (await response.json()) as AvailabilityInfoDTO;
  const res = transformAvailability(dto);
  return res;
}
